import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";

import Layout from "../../components/Layout";
import PageHero from "../../components/PageHero";
import InfoFooter from "../../components/InfoFooter";

import heroImage from "../../img/pano_56.jpeg";
import optometrieImage from "../../img/eyewear2_optimised.jpg";
import bryleImage from "../../img/eyewear3_optimised.jpg";
import cockyImage from "../../img/kontaktni-cocky.jpg";
import doplnkyImage from "../../img/eyewear1_optimised.jpg";
import converseLogo from "../../img/converse-eyewear-logo-white.png";
import bettyBarclayLogo from "../../img/bettybarclay_white.png";
import crocsLogo from "../../img/crocs-white.png";

const cards = [
  {
    id: "optometrie",
    to: "/sluzby/optometrie",
    image: optometrieImage,
    alt: "foto přístroje na měření zraku",
    title: "Optometrie",
    items: [
      "měření dioptrií kvalifikovaným optometristou",
      "při nákupu brýlí zdarma",
      "bez nutnosti objednání",
    ],
  },
  {
    id: "bryle",
    to: "/sluzby/bryle",
    image: bryleImage,
    alt: "Foto ženy s brýlemi",
    title: "Brýle",
    items: [
      "prodej dioptrických obrub",
      "široký sortiment dioptrických skel",
      "odborné poradenství",
      "záruční i pozáruční servis",
      "opravy",
    ],
  },
  {
    id: "cocky",
    to: "/sluzby/cocky",
    image: cockyImage,
    alt: "Foto kontaktních čoček",
    title: "Kontaktní čočky",
    items: [
      "vstupní vyšetření",
      "konzultace a výběr optimálních čoček",
      "aplikace",
      "nácvik",
    ],
  },
  {
    id: "doplnky",
    to: "/sluzby/doplnky",
    image: doplnkyImage,
    alt: "Foto slunečních brýlí",
    title: "Doplňkový prodej",
    items: [
      "sluneční brýle",
      "pouzdra",
      "čistící prostředky",
      "roztoky na kontaktní čočky",
    ],
  },
];

const brands = [
  { src: converseLogo, alt: "converse-eyewear-logo" },
  { src: bettyBarclayLogo, alt: "bettybarclay-logo" },
  { src: crocsLogo, alt: "crocs-logo" },
];

const Sluzby = () => (
  <Layout>
    <Helmet
      title="Produkty a služby | Optika Volyně"
      meta={[
        {
          name: "description",
          content:
            "Služby a produkty Optiky Volyně, které nabízí a poskytuje zákazníkům",
        },
        {
          name: "keywords",
          content:
            "Optika, Optometrie, Volyně, Brýle, Produkty, Služby, Čočky, Doplňky",
        },
      ]}
    />
    <main className="products-main">
      <PageHero
        image={heroImage}
        alt="ilustrační foto - interiér optiky"
        title="Nabídka"
        subtitle="produktů a služeb"
      />

      <div className="product-cards">
        {cards.map((card) => (
          <section className="product-card" id={card.id} key={card.id}>
            <img src={card.image} alt={card.alt} />
            <Link to={card.to}>
              <h2>{card.title}</h2>
            </Link>
            <ul>
              {card.items.map((item) => (
                <li key={item}>{item}</li>
              ))}
            </ul>
            <Link to={card.to} className="card-btn">
              více
            </Link>
          </section>
        ))}
      </div>

      <div className="brands-showcase">
        {brands.map((brand) => (
          <div className="brand-showcase-image" key={brand.alt}>
            <img src={brand.src} alt={brand.alt} />
          </div>
        ))}
      </div>

      <InfoFooter />
    </main>
  </Layout>
);

export default Sluzby;
